import React from "react"
import { Link } from "gatsby"

const ServicesCard = () => {
  return (
    <>
      <div className="services-area bg-f9f9f9 pt-100 pb-70">
        <div className="container">
          <div className="section-title">
            <span className="sub-title">Tính năng</span>
            <h2>Giải pháp An Phát eKYC</h2>
            <p>
              Bóc tách thông tin - So khớp chân dung - Xác thực chính danh
            </p>
          </div>

          <div className="row justify-content-center">
            <div 
              className="col-lg-4 col-md-6 col-sm-6"
              data-aos="fade-up"
              data-aos-duration="1200"
              data-aos-delay="100"
            >
              <div className="single-services-box">
                <div className="icon">
                  <i className="flaticon-megaphone"></i>
                  <div className="circles-box">
                    <div className="circle-one"></div>
                    <div className="circle-two"></div>
                  </div>
                </div>
                <h3>
                  <Link to="#">Phân Loại Ảnh</Link>
                </h3>
                <p>
                  Hệ thống của chúng tôi bắt đầu bằng việc phân loại ảnh, 
                  đánh giá liệu nó là giấy tờ quan trọng hay chân dung người dùng. 
                  Tiền xử lý ảnh bị xoay, nghiêng trước khi chuyển sang các bước tiếp theo.
                </p>

              </div>
            </div>

            <div 
              className="col-lg-4 col-md-6 col-sm-6"
              data-aos="fade-up"
              data-aos-duration="1200"
              data-aos-delay="200"
            >
              <div className="single-services-box">
                <div className="icon">
                  <i className="flaticon-keywords"></i>
                  <div className="circles-box">
                    <div className="circle-one"></div>
                    <div className="circle-two"></div>
                  </div>
                </div>
                <h3>
                  <Link to="#">Xác Minh Hình Ảnh</Link>
                </h3>
                <p>
                Tính năng xác minh hình ảnh của chúng tôi không chỉ đảm bảo rằng ảnh giấy tờ tuân theo các tiêu chuẩn nhất định 
                mà còn kiểm tra tính hợp lệ của nó. Ví dụ, ảnh giấy tờ mặt trước phải có ảnh khuôn mặt 3x4, 
                trong khi ảnh chân dung chỉ chứa một khuôn mặt rõ ràng trong khung hình.
                </p>

              </div>
            </div>

            <div 
              className="col-lg-4 col-md-6 col-sm-6"
              data-aos="fade-up"
              data-aos-duration="1200"
              data-aos-delay="300"
            >
              <div className="single-services-box">
                <div className="icon">
                  <i className="flaticon-content-management"></i>
                  <div className="circles-box">
                    <div className="circle-one"></div>
                    <div className="circle-two"></div>
                  </div>
                </div>
                <h3>
                  <Link to="#">Ngăn Chặn Giả Mạo</Link>
                </h3>
                <p>
                Đối với chúng tôi, an toàn là trên hết. Tính năng này không chỉ nhận diện trống giả mạo mà còn phòng 
                ngừa các kỹ thuật giả mạo thông dụng, chẳng hạn như chụp ảnh giấy tờ qua màn hình điện thoại, giấy tờ photo. 
                Bạn yên tâm, quá trình xác minh của chúng tôi an toàn và tin cậy.
                </p>


              </div>
            </div>

            <div 
              className="col-lg-4 col-md-6 col-sm-6"
              data-aos="fade-up"
              data-aos-duration="1200"
              data-aos-delay="400"
            >
              <div className="single-services-box">
                <div className="icon">
                  <i className="flaticon-ppc"></i>
                  <div className="circles-box">
                    <div className="circle-one"></div>
                    <div className="circle-two"></div>
                  </div>
                </div>
                <h3>
                  <Link to="#">Bóc Tách Thông Tin</Link>
                </h3>
                <p>
                Thực hiện quy trình xác minh một cách hiệu quả hơn, tính năng này không chỉ giúp chúng tôi 
                trích xuất thông tin từ giấy tờ một cách chính xác mà còn chuẩn hóa dữ liệu để đảm bảo tính nhất quán và dễ xử lý.
                </p>

              </div>
            </div>

            <div 
              className="col-lg-4 col-md-6 col-sm-6"
              data-aos="fade-up"
              data-aos-duration="1200"
              data-aos-delay="500"
            >
              <div className="single-services-box">
                <div className="icon">
                  <i className="flaticon-competitor"></i>
                  <div className="circles-box">
                    <div className="circle-one"></div>
                    <div className="circle-two"></div>
                  </div>
                </div>
                <h3>
                  <Link to="#">So Khớp Khuôn Mặt</Link>
                </h3>
                <p>
                Đây là bước xác minh chính danh, đảm bảo người chụp giấy tờ và chủ nhân của nó là một. 
                Tính năng so khớp khuôn mặt tự động của chúng tôi giúp đối chiếu khuôn mặt trên giấy tờ với ảnh chân dung, 
                đảm bảo sự khớp nhau và xác minh chính xác.
                </p>

              </div>
            </div>

            <div 
              className="col-lg-4 col-md-6 col-sm-6"
              data-aos="fade-up"
              data-aos-duration="1200"
              data-aos-delay="600"
            >
              <div className="single-services-box">
                <div className="icon">
                  <i className="flaticon-startup"></i>
                  <div className="circles-box">
                    <div className="circle-one"></div>
                    <div className="circle-two"></div>
                  </div>
                </div>
                <h3>
                  <Link to="#">Tính Năng Mở Rộng</Link>
                </h3>
                <p>
                  APCV còn phát triển thêm các mô hình học sâu hỗ trợ việc đọc mã QR, MRZ, đọc thẻ SIM và nhiều tính năng khác để 
                  tối ưu hóa quy trình xác minh KYC. 
                  Tính linh hoạt này giúp doanh nghiệp thích ứng với nhu cầu đặc biệt của họ, 
                  mang lại trải nghiệm xác minh linh hoạt và toàn diện
                </p>

              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default ServicesCard
